
import { Component, Vue } from 'vue-property-decorator';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import PageHeader from '@/components/PageHeader.vue';
import TopFooterButton from '@/components/TopFooterButton.vue';
import TopContentTitle from '@/components/TopContentTitle.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentPrivacyPolicy from '@/components/TopContentPrivacyPolicy.vue';
import TopContentTermsOfService from '@/components/TopContentTermsOfService.vue';

@Component({
  components: {
    PageHeader,
    TopFooterButton,
    TopContentTitle,
    TopContentText,
    TopContentPrivacyPolicy,
    TopContentTermsOfService
  }
})
export default class TermsOfUse extends Vue {
  private isFirstLoading: boolean = false;
  private isSection1Loading: boolean = true;
  private isSection2Loading: boolean = true;
  private isLastLoading: boolean = false;
  private isScrollEnd: boolean = false;
  private timerId: number = -1;

  private get orgName(): string {
    return this.$store.getters['auth/currentLanguageOrgName'];
  }

  private get privacyPolicyVersion(): number {
    return this.$store.getters['terms/privacyPolicyVersion'];
  }

  private get termsOfServiceVersion(): number {
    return this.$store.getters['terms/termsOfServiceVersion'];
  }

  // 初期化処理
  private async created(): Promise<void> {
    try {
      this.isFirstLoading = true;
      const applicantId: number = this.$store.getters['auth/applicantId'];
      await this.$store.dispatch('terms/storeAgreementVersion', applicantId);
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isFirstLoading = false;
    }

    // 初期化完了してからスクロール確認
    await this.$nextTick();
    this.checkScroll();
  }

  // アンマウント時
  private beforeDestroy(): void {
    window.clearTimeout(this.timerId);
  }

  // スクロール確認処理
  private checkScroll(): void {
    if (this.$store.getters['camera/isPC']) {
      // PC版はスクロール制御を行わない
      this.isScrollEnd = true;
    } else if (this.isFirstLoading || this.isSection1Loading || this.isSection2Loading) {
      // ロード中はスクロールが完了しない
      this.isScrollEnd = false;
    } else {
      // SP版はスクロールし終えるまでボタンを無効化
      const margin: number = 20;
      const section: HTMLElement = document.body.getElementsByTagName('section').item(0)!;
      this.isScrollEnd = window.scrollY + window.innerHeight >= section.scrollHeight - margin;
    }

    if (!this.isScrollEnd) this.timerId = window.setTimeout((): void => this.checkScroll(), 200);
  }

  // 次のページへ行く
  private async next(): Promise<void> {
    try {
      this.isLastLoading = true;
      const applicantId: number = this.$store.getters['auth/applicantId'];
      await this.$store.dispatch('terms/storeIsAgree', applicantId);
      this.$store.commit('auth/setAgree', true);
      this.$router.push('/top/personal-information');
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLastLoading = false;
    }
  }
}
